// X-Request-Id generation for client requests (API-8). The id is echoed by the
// server and propagated across Worker↔DO↔Queue↔Workflow (INF-42), so every client
// call is traceable end-to-end. Uses the platform Web Crypto UUID where available
// (Workers, modern Expo/RN, browsers); falls back to a non-cryptographic id only
// when crypto.randomUUID is absent. No Node APIs.

export function generateRequestId(): string {
  const c: Crypto | undefined = globalThis.crypto;
  if (c && typeof c.randomUUID === 'function') {
    return c.randomUUID();
  }
  const rand = Math.random().toString(36).slice(2, 12);
  return `req_${Date.now().toString(36)}${rand}`;
}
